export interface ICharacterAttribute {
	character: string;
	characterCode: number;
	mastery: string;
	controlDifficulty: number;
	attack: number;
	defense: number;
	disruptor: number;
	move: number;
	assistance: number;
}
